import { get } from "../../utils/objectHelpers";

$ {
    const accessibilityText = get(input, "accessibilityText", "");
    // TODO add tracking to action.type === "NAV"
    const action = get(input, "action", {});
    const target = get(input, "target", null);
    const wrapper = get(input, "wrapper", null);
    const tabIndex = get(input, "tabindex", null);
    const customCssClasses = get(input, "class", "");
    const spanContainers = get(input, "spanContainers", null);
    const href = action.URL ? { href: action.URL } : null;
    const targetAttr = href && target ? { target } : null;
    const tabIndexAttr = tabIndex ? { tabindex: tabIndex } : null;
    const cssClasses = customCssClasses.length ? { class: customCssClasses } : null;
    const ariaLabel = accessibilityText.length ? { "aria-label": accessibilityText } : null;
    const tracking = get(action, "trackingList.0");
    const trackingAttr = tracking ? { "data-track": JSON.stringify(tracking) } : null;
    const rawTextSpans = get(input, "textSpans", []);
    const customParser = get(input, "customParser", null);
    const attrs = { ...href, ...targetAttr, ...cssClasses, ...ariaLabel, ...tabIndexAttr, ...trackingAttr };
    const hasWrappingAttrs = rawTextSpans.length > 1 || href || trackingAttr || tabIndexAttr || wrapper;
    const textSpans = rawTextSpans.map(textSpan => {
        if (!accessibilityText.length) {
            return textSpan;
        } else if (hasWrappingAttrs) {
            return { ...textSpan, ariaHidden: true };
        } else {
            return { ...textSpan, accessibilityText };
        }
    });
    const container = hasWrappingAttrs ? (href ? "a" : wrapper ? wrapper : "span") : null;
}

<${container} ...attrs>
    <str-text-span
        allowHtml= get(input, "allowHtml", false)
        customParser=customParser
        spanContainers=spanContainers
        textSpans=textSpans
        target=target
        ...(!hasWrappingAttrs ? attrs : {})
    />
</>
